var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageBgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1300,
    viewBox: "0 0 1440 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1100_4397)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1100_4397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 397.765,
    height: 1692.64,
    rx: 198.882,
    transform: "matrix(0.642788 -0.766044 0.766248 0.642545 -129.658 45.7055)",
    fill: "url(#paint0_linear_1100_4397)",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4189,
    y: -1.35143,
    width: 375.879,
    height: 1084.3,
    rx: 187.94,
    transform: "matrix(0.642788 -0.766044 0.766248 0.642545 -173.457 600.795)",
    stroke: "url(#paint1_linear_1100_4397)",
    strokeOpacity: 0.18,
    strokeWidth: 21.8858
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1100_4397",
    x: -145.948,
    y: -224.975,
    width: 1534.9,
    height: 1491.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.6312,
    result: "effect1_foregroundBlur_1100_4397"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1100_4397",
    x1: 244.806,
    y1: -364.447,
    x2: 203.822,
    y2: 1692.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145708,
    stopColor: "#D0FBEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373644,
    stopColor: "#C3F8E9",
    stopOpacity: 0.536558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AEDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1100_4397",
    x1: 198.882,
    y1: 0,
    x2: 198.882,
    y2: 1106.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0FBEF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1100_4397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageBgIc);
export default __webpack_public_path__ + "static/media/homepageBg_ic.bd5941ed.svg";
export { ForwardRef as ReactComponent };